module.exports = __webpack_public_path__ + "img/driverLocBusy.6571d4c3.svg";